import { SVGProps } from 'react'

export const NuxtIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.53 11.008c-.832-1.43-2.91-1.43-3.742 0L5.726 26.59c-.832 1.43.208 3.216 1.87 3.216h7.075c-.71-.62-.974-1.695-.436-2.617L21.1 15.424l-2.57-4.416Z"
      fill="#80EEC0"
    />
    <path
      d="M24.272 14.426c.688-1.17 2.409-1.17 3.097 0l7.5 12.748c.688 1.17-.172 2.633-1.549 2.633h-15c-1.376 0-2.236-1.463-1.548-2.633l7.5-12.748Z"
      fill="#00DC82"
    />
  </svg>
)
